import React from 'reactn';
import { DeepClone, dosDeciComas } from 'util/functions';
import { UnidadBase } from './UnidadBase.atomo';
export const UnidadKg = (props, column) => <UnidadBase {...props} column={column} unidad="kg" />;
export const UnidadKilos = (props, column) => <UnidadBase {...props} column={column} unidad="kg" />;
export const UnidadKilosBg = (props, column) => {
    const copia = DeepClone(props)
    if (column.field && copia?.[column.field]) { copia[column.field] = dosDeciComas(copia[column.field]) }
    return <UnidadBase {...copia} column={column} claseExtra="unidad-kg-bold" unidad="kg" />;
}